import { Backdrop, Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../App";
import moment from "moment";
import 'moment/locale/fr';

export default function CmdInfo({ commande, close }) {
    const {setIsConnected } = useContext(Context)
    const [load, setLoad] = useState(true);
    const [billets, setBillets] = useState([]);

    useEffect(()=> {
        setLoad(true);

        const query = {_id: {$in: commande.items.map(item => item.id?._id)}};

        fetch(process.env.REACT_APP_API_URL.concat('/billets'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify(query)
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setBillets(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching billets:", error);
        }).finally(() => {
            setLoad(false);
        });
    }, [commande]);

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, p: 2}}>
            <Typography variant="h4" align="center">Commande N° {commande.num}</Typography>

            <Typography variant="body1" lineHeight={1.8}>
                <span style={{fontWeight:'bold'}}>Client:</span> <span style={{textTransform:'capitalize'}}>{commande.user? (commande.user.nom+' '+commande.user?.prenom) : ' -- '}</span><br/>
                <span style={{fontWeight:'bold'}}>Email:</span> {commande.user?.mail || ' -- '}<br/>
                <span style={{fontWeight:'bold'}}>Date de la commande:</span> {moment(commande.createdAt).format('DD/MM/YYYY HH:mm')}<br/>
                <span style={{fontWeight:'bold'}}>Statut:</span> {commande.statut}<br/>
                <span style={{fontWeight:'bold'}}>Numéro de reçu:</span> {commande.recuNum || ' --'}
            </Typography>
            
            {billets.length>0 && <Typography variant="h5" textAlign='center' fontWeight='bold'>Billets</Typography>}
            {billets.map( billet =>
                <Stack key={billet._id} direction="row" spacing={2} alignItems="center" justifyContent={'space-between'}>
                    <Box>
                        <Typography variant="h6" textTransform='capitalize'>{billet.event?.titre} - {billet.tarif}</Typography>
                        <Typography variant="body1" fontSize={14}>billet au nom de <span style={{textTransform:'capitalize'}}>{billet.owner?.nom+' '+billet.owner?.prenom}</span></Typography>
                    </Box>
                    <Typography variant="body1">{billet.price?.toFixed(2)} €</Typography>
                </Stack>
            )}

            {commande.payments.length > 0 && <Typography variant="h5" textAlign='center' fontWeight='bold'>Paiements</Typography>}
            {commande.payments.map((payment, index) => (
                <Box key={index} sx={{border: '1px solid #ccc', padding: 2, borderRadius: 1}}>
                    <Typography variant="body1"><span style={{fontWeight:'bold'}}>Code de transaction:</span> {payment.txCode || ' --'}</Typography>
                    <Typography variant="body1"><span style={{fontWeight:'bold'}}>Montant:</span> {payment.montant?.toFixed(2)} €</Typography>
                    <Typography variant="body1"><span style={{fontWeight:'bold'}}>Statut:</span> {payment.status || ' --'}</Typography>
                    {payment.status === 'Échouée' && <Typography variant="body1"><span style={{fontWeight:'bold'}}>Code d’échec:</span> {payment.failureCode || ' --'}</Typography>}
                    {payment.status === 'Échouée' && <Typography variant="body1"><span style={{fontWeight:'bold'}}>Raison de l’échec:</span> {payment.failureMessage || ' --'}</Typography>}
                    <Typography variant="body1"><span style={{fontWeight:'bold'}}>Date:</span> {moment(payment.date).format('DD/MM/YYYY HH:mm')}</Typography>
                    <Typography variant="body1"><span style={{fontWeight:'bold'}}>Fournisseur:</span> {payment.provider || ' --'}</Typography>
                    <Typography variant="body1"><span style={{fontWeight:'bold'}}>Devise:</span> {payment.currency || ' --'}</Typography>
                    <Typography variant="body1"><span style={{fontWeight:'bold'}}>Mode de paiement:</span> {payment.mode || ' --'}</Typography>
                </Box>
            ))}

            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 2}}>
                <Typography variant="h6">Montant total de la commande: </Typography>
                <Typography variant="h6">{billets.reduce((total, billet) => total + (billet.price || 0), 0)?.toFixed(2)} €</Typography>
            </Box>

            <Button variant="outlined" color="primary" onClick={close} sx={{mt: 2, alignSelf:'end'}}>Fermer</Button>
        </Box>
    )
}